import { render, staticRenderFns } from "./FireAlertsColumnsSelector.vue?vue&type=template&id=46b4a430"
import script from "./FireAlertsColumnsSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./FireAlertsColumnsSelector.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports